import AV from 'leancloud-storage'

export const site = {
  state() {
    return {
      banner: null
    }
  },
  mutations: {
    setBanner(state, payload) {
      state.banner = payload
    },
  },
  actions: {
    loadBanner({ commit }) {
      return AV.Cloud.rpc("getH5BannerByHost", { host: window.location.host }).then((banner) => {
        commit('setBanner', banner)
      });
    }
  },
  getters: {
    banner: state => state.banner
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/site/index.js